import { Box } from 'components/widgets/Box'
import { Text } from 'components/widgets/Text'
import React from 'react'

import { CollapsibleSection } from 'widgets/CollapsibleSection'

import { Program } from 'types/program'

type WorkoutsSectionProps = {
  program?: Program
}

export const WorkoutsSection = ({ program }: WorkoutsSectionProps) => {
  return (
    <CollapsibleSection
      sectionTitle='Edit Workouts'
      bodyContent={
        <Box padding='smd' backgroundColor='v2lightGrey'>
          <Text>Under development!</Text>
        </Box>
      }
    />
  )
}
